( function( $ ) {
	// Variables
	const $tabLink = $( '#tabs-section .tab-link' );
	const $tabBody = $( '#tabs-section .tab-body' );
	let timerOpacity;

	// Toggle Class
	const init = () => {
		// Menu Click
		$tabLink.off( 'click' ).on( 'click', function( e ) {
			// Prevent Default
			e.preventDefault();
			e.stopPropagation();

			// Clear Timers
			window.clearTimeout( timerOpacity );

			// Toggle Class Logic
			// Remove Active Classes
			$tabLink.removeClass( 'active ' );
			$tabBody.removeClass( 'active ' );
			$tabBody.removeClass( 'active-content' );

			// Add Active Classes
			$( this ).addClass( 'active' );
			$( $( this ).attr( 'href' ) ).addClass( 'active' );

			// Opacity Transition Class
			timerOpacity = setTimeout( () => {
				$( $( this ).attr( 'href' ) ).addClass( 'active-content' );
			}, 100 );
		} );
	};

	// Document Ready
	$( function() {
		init();
	} );
}( jQuery ) );




document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".accordion-item");

  items.forEach((item) => {
    item.addEventListener("click", function () {
      if (!this.classList.contains("active")) {
        closeAllAccordions();
        this.classList.add("active");
      }
    });
  });

  // Open the first accordion item on load
  $(this).addClass("active");
});

function closeAllAccordions() {
  const items = document.querySelectorAll(".accordion-item");
  items.forEach((item) => {
    item.classList.remove("active");
  });
}


$(document).ready(function () {

  var checkBox = document.getElementById("privacy");
  var checkBox_label = document.getElementById("privacy_label");
  var button = document.getElementById("Subscribe");
  var button_box = document.getElementById("contact_submit");
if (checkBox){
  if (checkBox.checked) {
    $(button).attr("disabled", false);
    $(button).attr("style", '');
  } else {
    $(button).attr("disabled", true);
    $(button).attr("style", 'pointer-events: none;');
  }

  $(checkBox).change(function () {
    if (this.checked) {
      $(button).attr("disabled", false);
      $(checkBox_label).css("color", "inherit");
      $(button).attr("style", '');
    } else {
      $(button).attr("disabled", true);
      $(checkBox_label).css("color", "red");
      $(button).attr("style", 'pointer-events: none;');
    }
  });
}
});



$(document).ready(function(){
	
	$('ul.iwp-tabs li.iwp-link').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.iwp-tabs li.iwp-link').removeClass('current');
		$('.iwp-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	})

})

$('.tab-a5').hide()
jQuery('.show-taba5').on('click',function(){
  jQuery('.tab-a5').toggle();
  jQuery('.show-taba5').toggleClass('clicked');
})

$('.tab-b5').hide()
jQuery('.show-tabb5').on('click',function(){
  jQuery('.tab-b5').toggle();
  jQuery('.show-tabb5').toggleClass('clicked');
})




